<template lang="pug">	
	.flex-col.campaign-budget-fee.space.align-right-editors
		.flex-row.justify.align-center(v-for="item in budget.Fees")
			.flex-row
				.adt-button.clickable.flex-row.center.align-center.rounded(v-if="item.Oid && !info.readonly", @click="removeFee(item)", :title="$tCaption('Remove fee')")
					fas(icon="times", size="2xs")
				EditableLabel(ref="feeNameLabel", :disabled="info.readonly")
					span {{item.Name || $tCaption('Edit', '@actions')}}
					template(slot="editor")
						DxTextBox(:value.sync="item.Name", @value-changed="updateFee(item); $refs.feeNameLabel.map(f => f.release())")
			.flex-row
				.data-value
					DxNumberBox.bool.number-edit(:value.sync="item.Fee", @value-changed="updateFee(item)", :format="currencyFormat", :disabled="info.readonly")
				.recurrent-period.flex-row.space
					DxCheckBox(:value.sync="item.Recurrent", @value-changed="updateFee(item)", :text="recurrencyPeriod", :disabled="info.readonly")
		.flex-row.justify-end
			.adt-button.clickable.flex-row.center.align-center.rounded.padded-lg(v-if="!info.readonly", @click="addFee", :title="$tCaption('Add fee')")
				fas(icon="plus", size="2xs")
</template>

<script>
	import _ from 'lodash';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import EditableLabel from 'app-core/EditableLabel.vue';
	import DxTextBox from 'devextreme-vue/text-box';

	export default {
		translationCategory: 'campaign.Budget',
		name: 'campaign-budget',
		components: {
			DxNumberBox, DxCheckBox, EditableLabel, DxTextBox
		},
		props: ['info', 'budget', 'recurrencyPeriod', 'currencyFormat'],
		data() {
			return {
				
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.budgetFee = this;
		},
		destroyed() {
		
		},
		methods: {
			updateFee(fee) {
				this.createUpdateCampaignBudgetFee(fee);
				this.$emit('change', this.budget);
			},
			removeFee(fee) {
				if (!fee.Oid) return;
				
				this.$confirmMessage({
					title: () => this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to remove fee?'),
					handler: () => {
						const feeIdx = this.budget.Fees.findIndex(f => f === fee);
						this.budget.Fees.splice(feeIdx, 1);
						this.$Data.postExternalApi('CampaignBudgetFee/DeleteBudgetFees', [fee.Oid]);
						this.$emit('change', this.budget);
					}
				});
			},
			addFee() {
				const fee = {
					Name: `${this.$tCaption('Fee')} ${this.budget.Fees.length}`,
					Fee: 0,
					Recurrent: false,
					BudgetId: this.budget.Oid
				};

				this.budget.Fees.push(fee);
				this.createUpdateCampaignBudgetFee(fee);
				this.$emit('change', this.budget);
			},
			createUpdateCampaignBudgetFee(fee) {
				return this.$Data.postExternalApi('CampaignBudgetFee/CreateUpdateBudgetFee', fee).then(r => {
					if (!fee?.Oid && r?.Data?.Oid) {
						fee.Oid = r.Data.Oid;
					}
				})
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.campaign-budget-fee{
		.dx-checkbox {
			font-size: 11px !important;
		}
	}
</style>
